import React, { useState, useEffect } from "react";

/**
 * PromoCountdown — affiche "🔥 Promo limitée — JJj HHh MMm SSs"
 *
 * Props:
 *  - endsAt: ISO date string ("2026-06-30T23:59:59")
 *  - variant: "card" (compact, full-width banner) | "sticky" (taller, for pricing card)
 *
 * Comportement :
 *  - Si la date est passée → ne rend rien (la promo est expirée)
 *  - Mise à jour toutes les secondes
 */
export const PromoCountdown = ({ endsAt, variant = "card" }) => {
  const target = new Date(endsAt).getTime();
  const computeRemaining = () => Math.max(0, target - Date.now());
  const [remaining, setRemaining] = useState(computeRemaining());

  useEffect(() => {
    if (remaining <= 0) return undefined;
    const id = setInterval(() => setRemaining(computeRemaining()), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target]);

  if (remaining <= 0) return null;

  const seconds = Math.floor(remaining / 1000);
  const d = Math.floor(seconds / 86400);
  const h = Math.floor((seconds % 86400) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  const pad = (n) => String(n).padStart(2, "0");

  if (variant === "sticky") {
    return (
      <div
        className="bg-gradient-to-r from-red-500 to-[#F07B1D] text-white rounded-lg p-3 mb-4 text-center shadow-md"
        data-testid="promo-countdown-sticky"
      >
        <div className="flex items-center justify-center gap-2 mb-1">
          <span className="text-base">🔥</span>
          <span className="text-xs font-bold uppercase tracking-wider">Promo limitée</span>
        </div>
        <div className="flex items-center justify-center gap-1.5 font-mono font-bold text-sm">
          <span className="bg-white/20 px-2 py-1 rounded">{pad(d)}j</span>
          <span className="bg-white/20 px-2 py-1 rounded">{pad(h)}h</span>
          <span className="bg-white/20 px-2 py-1 rounded">{pad(m)}m</span>
          <span className="bg-white/20 px-2 py-1 rounded">{pad(s)}s</span>
        </div>
      </div>
    );
  }

  // variant === "card"
  return (
    <div
      className="absolute top-0 left-0 right-0 bg-gradient-to-r from-red-500 to-[#F07B1D] text-white text-xs font-bold py-1.5 px-3 flex items-center justify-between z-20 shadow-sm"
      data-testid="promo-countdown-card"
    >
      <span className="flex items-center gap-1.5">
        <span>🔥</span>
        <span className="uppercase tracking-wider text-[10px]">Promo limitée</span>
      </span>
      <span className="font-mono">
        {pad(d)}j {pad(h)}h {pad(m)}m {pad(s)}s
      </span>
    </div>
  );
};

export default PromoCountdown;
